export default __webpack_public_path__ + "static/media/icon-instagram.e68ddcb8.svg";